<div>
    <p-card class="basin-mb-6">
        <div class="card-content">
            <h5 class="headline-5 basin-mb-4">Review your study area</h5>

            <p class="basin-font-primary basin-mb-3">
                You're almost there! Please review the details of your study area and click "Confirm" to proceed.
            </p>

            <div [ngClass]="isStudyAreaVisible ? 'basin-flex-row': 'basin-flex-column' "
                class="basin-display-flex basin-flex-justify-content-end map-main-container">
                <div class="map-left-panel">
                    <div class="basin-mb-3 left-panel-table-height">
                        <p-table class="basin-table-height" [value]="licenseStudyAreas">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th scope="col">Study Area</th>
                                    <th scope="col">Created By</th>
                                    <th scope="col">Size</th>
                                    <th scope="col">Area Remaning in License</th>

                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-area>
                                <tr>
                                    <td>{{ area.studyAreaName }}</td>
                                    <td>{{ area.createdBy }}</td>
                                    <td>{{ area.currentSize }} {{ area.areaUnit }} </td>
                                   <td> {{ area.remainingArea == -1 ? '-' : (area.remainingArea + ' ' + area.areaUnit) }}</td>

                                </tr>
                            </ng-template>

                        </p-table>
                    </div>

                    <div class="basin-flex-row basin-display-flex basin-justify-content-space-between">

                        <div class="basin-display-flex basin-justify-content-flex-start">
                            <button class="p-button p-button-text" aria-label="Cancel" (click)="changeStep()">
                                <span class="icon-chevron-left basin-mr-1"></span>Back
                            </button>
                        </div>

                        <div class="basin-display-flex basin-justify-content-flex-end">
                            <button class="p-button p-button-text basin-mr-3" (click)="goToHomePage()">Cancel</button>
                            <button class="p-button" aria-label="Continue" (click)="confirmedStudyAreaPopup()">
                                <span class="p-button-icon p-button-icon-left icon-done"></span>
                                Confirm
                            </button>
                        </div>
                    </div>

                    <div class="custom-toggle-btn" id="column-toggle-btn">
                        <button class="column-toggle" [ngClass]="{ 'column-toggle-closed': isStudyAreaVisible }"
                            (click)="toggleStudyAreaPanel()" pTooltip="Show/Hide User Created Study Areas"
                            tooltipPosition="left" tooltipStyleClass="p-tooltip-white">
                            <span class="toggle-arrow-icon"
                                [ngClass]="isStudyAreaVisible ? 'symbol-arrow-right': 'symbol-arrow-left' "></span>
                        </button>
                    </div>
                </div>
                <div class="map-right-panel basin-pl-4" *ngIf="isStudyAreaVisible">
                    <app-available-study-area [licenseStudyAreas]="licenseStudyAreaData"
                        [isClickable]="isAvailableListClickable" (selectStudyArea)="onStudyAreaClick($event)"
                        [parentClassName]="'review-study-area'"></app-available-study-area>
                </div>
            </div>
        </div>
    </p-card>
</div>

<p-confirmDialog></p-confirmDialog>